// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_2gpQDBFrRTHIMzbCX1o_oT","up":"_3gCXg0DQT9oTVC3EZyux_k","left":"_5acZtf5_tsQixvKg2kvnj","right":"_3IuhaqczsbTMnZjhexilGE"};